module.exports = __webpack_public_path__ + "img/salad.5799a4ab.png";